import { NPC, Question, NPCResponse } from "./NPC";

export class GameState {
    public currentNPC: NPC;
    // Current question being answered by NPC
    public question: Question;
    // NPC's response to the current question
    public response: NPCResponse;

    constructor(npc: NPC) {
        this.currentNPC = npc;
    }


    /**
     * Dynamically changes with each scene!!!
     */
    public static current: GameState;

}



// WEBPACK FOOTER //
// ./src/games/FitFiveGame/objects/GameState.ts